module.exports = __webpack_public_path__ + "07_long_beige.8ed664c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_long_beige.png
// module id = oP9f
// module chunks = 0